package org.maplibre.compose.interaction.internal

import androidx.compose.runtime.Composable

@Composable internal actual fun rotaryNotchPixels(): Float = 0f
